import React from 'react';

export const Card = React.forwardRef(({ children, className }, ref) => {
    return (
        <div ref={ref} className={`bg-white shadow-md rounded-lg p-4 ${className}`}>
            {children}
        </div>
    );
});

export const CardContent = ({ children, className }) => {
    return (
        <div className={`p-4 ${className}`}>
            {children}
        </div>
    );
};

